import type { TaskCTAProps } from './TaskCTABlock.types';
import ButtonCircle from '../ButtonCircle';

const TaskCTA: React.FC<TaskCTAProps> = ({
  title,
  summary,
  imageLink,
  link,
  targetAttr,
  isExternalURL,
}) => {
  const classes = `task-cta__button button--secondary ${
    isExternalURL ? 'button--external' : ''
  }`;

  const TaskCTAElement = link ? 'a' : 'div';
  return (
    <div className="task-cta">
      {imageLink && (
        <div
          className="task-cta__image"
          style={{
            backgroundImage: `url(${imageLink})`,
          }}
        />
      )}
      <TaskCTAElement
        className="task-cta__card"
        href={link}
        target={targetAttr && '_blank'}
        rel={targetAttr && 'noopener'}
      >
        <h3 className="task-cta__heading h4">{title}</h3>
        <div
          className="task-cta__summary"
          dangerouslySetInnerHTML={{ __html: summary }}
        />
        {link && (
          <span className={classes}>
            <ButtonCircle
              arrowHeight={17}
              arrowWidth={21}
              arrowFill="#ffffff"
            />
          </span>
        )}
      </TaskCTAElement>
    </div>
  );
};

export default TaskCTA;
